import { BodyText } from "@/components/ui";
import { QuestionnaireResponse } from "@curai/js-fhir-tools";
import type * as fhirTypes from "fhir/r4";
import { CheckCheck, LoaderCircle, PenTool } from "lucide-react";
import { formatAuthoredDate, formatQuestionnaireScore } from "../../utils";

interface QuestionnaireDetailDialogFooterProps {
  questionnaireResponse: fhirTypes.QuestionnaireResponse;
  responseScore?: number | null;
  maxScore?: number | null;
}

export const QuestionnaireDetailDialogFooter = ({
  questionnaireResponse,
  responseScore,
  maxScore,
}: QuestionnaireDetailDialogFooterProps) => {
  const qr = new QuestionnaireResponse(questionnaireResponse);
  const actorName = qr.getConfirmationActorName();
  const occurredDate = qr.getConfirmationOccurredDate();

  const StatusIcon =
    questionnaireResponse.status === "completed" ? PenTool : LoaderCircle;
  const statusText =
    questionnaireResponse.status === "completed"
      ? "Completed by"
      : "In Progress by";
  const authorName = questionnaireResponse.author?.display || "Unknown";
  const lastUpdated = formatAuthoredDate(questionnaireResponse.authored, false);

  return (
    <div className="flex-shrink-0">
      <div className="flex items-center space-x-1 mb-2">
        <StatusIcon className="w-3 h-3 stroke-neutral-500" aria-hidden="true" />
        <BodyText size="xs" textColor="tertiary">
          {statusText} {authorName} on {lastUpdated}
        </BodyText>
      </div>

      {actorName && occurredDate && (
        <div className="flex items-center space-x-1 mb-2">
          <CheckCheck
            className="w-3 h-3 stroke-neutral-500"
            aria-hidden="true"
          />
          <BodyText size="xs" textColor="tertiary">
            Reviewed by {actorName} on {formatAuthoredDate(occurredDate, false)}
          </BodyText>
        </div>
      )}

      <div className="flex flex-col space-y-1 p-3 bg-neutral-100 rounded-lg">
        <BodyText size="sm">Total Score</BodyText>
        <BodyText bold size="md">
          {formatQuestionnaireScore(responseScore, maxScore, "--")}
        </BodyText>
      </div>
    </div>
  );
};
